import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=9f8dc77e&scoped=true&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=9f8dc77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8dc77e",
  null
  
)

export default component.exports